import React from 'react';
import Reveal from './Reveal';

const BENEFITS = [
  {
    title: 'Esprit plus vif',
    text: 'Améliorez mémoire, concentration et fonctions cognitives grâce à un entraînement régulier et varié.',
  },
  {
    title: 'Réduction du stress',
    text: 'Apprenez des techniques de pleine conscience pour gérer la tension et cultiver le calme.',
  },
  {
    title: 'Meilleure humeur',
    text: 'Renforcez résilience émotionnelle et positivité, avec le soutien d’une communauté engagée.',
  },
];

export default function Avantages() {
  return (
    <section className="py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-copper-600">
            Les bénéfices
          </p>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight max-w-xl">
            Pour qui cherche à prendre soin de son esprit.
          </h2>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-3 gap-6">
          {BENEFITS.map((item, i) => (
            <Reveal key={item.title} delay={i * 80}>
              <article className="rounded-2xl bg-pine-600 text-parchment p-8 h-full">
                <span className="font-display text-6xl font-semibold text-pine-500/80 leading-none">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-8 font-display text-2xl font-semibold">{item.title}</h3>
                <p className="mt-3 text-parchment/75 leading-relaxed">{item.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
